export const ACCESSIBLE_RESOURCES_QUERY_KEY = 'ACCESSIBLE_RESOURCES';
export const LIST_PROJECTS_QUERY_KEY = 'LIST_PROJECTS_QUERY_KEY';
export const SEARCH_PROJECTS_QUERY_KEY = 'SEARCH_PROJECTS_QUERY_KEY';
export const AVAILABLE_PROJECT_PROVIDERS_QUERY = 'AVAILABLE_PROJECT_PROVIDERS_QUERY';

export const API_URLS = {
  ProjectManagementSystem: process.env.REACT_APP_PROJECT_MANAGEMENT_SYSTEM_API_URL,
};
